import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Tooltip from './Tooltip';

function useCounter(target, duration = 1200) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!target) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setVal(target); clearInterval(timer); }
      else setVal(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  return val;
}

function fmt(n) {
  if (n >= 1e9) return (n / 1e9).toFixed(1) + 'B';
  if (n >= 1e6) return (n / 1e6).toFixed(1) + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return String(n);
}

export default function MetricCard({ icon: Icon, label, value, color, tooltip, prefix = '', suffix = '', index = 0 }) {
  const counted = useCounter(typeof value === 'number' ? value : 0);
  const display = typeof value === 'number' ? fmt(counted) : value;

  return (
    <Tooltip content={tooltip}>
      <motion.div
        className="metric-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeOut' }}
        whileHover={{ y: -6, transition: { type: 'spring', stiffness: 360, damping: 24 } }}
        whileTap={{ scale: 0.97 }}
      >
        <div className="m-icon-wrap" style={{ color: color || 'var(--accent)' }}>
          {Icon && <Icon size={20} />}
        </div>
        <div className="m-val" style={{ color: color || 'var(--accent)' }}>
          {prefix}{display || '—'}{suffix}
        </div>
        <div className="m-label">{label}</div>
        <div className="m-trend">↑ analytics</div>
      </motion.div>
    </Tooltip>
  );
}
